import React from 'react';
import { ChangeDateModalTemplate } from 'themes/application/schedule/components';
import { observer } from 'mobx-react';
import { ChangeDateModalStore } from 'application/schedule/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new ChangeDateModalStore(rootStore, componentProps), 'changeDateModalStore')
@observer
class ChangeDateModal extends React.Component {
    render() {
        return <ChangeDateModalTemplate {...this.props} />
    }
}

export default ChangeDateModal;